export default "__VITE_ASSET__DiSPjUFS__"